export const GENERATE_TEST_SUCCESS="test/GENERATE_TEST_SUCCESS";
export const GENERATE_TEST_FAILURE="test/GENERATE_TEST_FAILURE";
export const TEST_RESULT_SUCCESS="test/TEST_RESULT_SUCCESS";
export const TEST_RESULT_FAILURE="test/TEST_RESULT_FAILURE";
export const CORRECT_ANSWERS_SUCCESS="test/CORRECT_ANSWERS_SUCCESS";
export const CORRECT_ANSWERS_FAILURE="test/CORRECT_ANSWERS_FAILURE";
export const RESULT_SUGGESTIONS_SUCCESS="test/RESULT_SUGGESTIONS_SUCCESS";
export const RESULT_SUGGESTIONS_FAILURE="test/RESULT_SUGGESTIONS_FAILURE";
export const SUBJECT_CHAPTER_SUCCESS="test/SUBJECT_CHAPTER_SUCCESS";
export const SUBJECT_CHAPTER_FAILURE="test/SUBJECT_CHAPTER_FAILURE";
export const HISTORY_SUCCESS="test/HISTORY_SUCCESS";
export const HISTORY_FAILURE="test/HISTORY_FAILURE";
export const FUTURE_ASSIGNMENT_SUCCESS="test/FUTURE_ASSIGNMENT_SUCCESS";
export const FUTURE_ASSIGNMENT_FAILURE="test/FUTURE_ASSIGNMENT_FAILURE";
export const FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS="test/FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS";
export const FUTURE_ASSIGNMENT_QUESTIONS_FAILURE="test/FUTURE_ASSIGNMENT_QUESTIONS_FAILURE";
export const SUBMISSION_DATA_SUCCESS="test/SUBMISSION_DATA_SUCCESS";
export const SUBMISSION_DATA_FAILURE="test/SUBMISSION_DATA_FAILURE";
export const SUBMIT_ANSWERS_SUCCESS="test/SUBMIT_ANSWERS_SUCCESS";
export const SUBMIT_ANSWERS_FAILURE="test/SUBMIT_ANSWERS_FAILURE";
export const SEE_ANSWERS_SUCCESS="test/SEE_ANSWERS_SUCCESS";
export const SEE_ANSWERS_FAILURE="test/SEE_ANSWERS_FAILURE";
export const ASSIGNMENT_IN_PROGRESS_SUCCESS="test/ASSIGNMENT_IN_PROGRESS_SUCCESS";
export const ASSIGNMENT_IN_PROGRESS_FAILURE="test/ASSIGNMENT_IN_PROGRESS_FAILURE";
export const HISTORY_NOT_ATTEMPTED_SUCCESS="test/HISTORY_NOT_ATTEMPTED_SUCCESS";
export const HISTORY_NOT_ATTEMPTED_FAILURE="test/HISTORY_NOT_ATTEMPTED_FAILURE";
